import { InAppBrowserOptions } from "./model/inAppBrowserOptions";

export const defaultInAppBrowserConfig: InAppBrowserOptions = {
  location: "no",
  hidenavigationbuttons: "yes",
  hideurlbar: "yes",
  toolbarcolor: "#0F3549",//"#050b7f",
  closebuttoncolor: "#ffffff",
  closebuttoncaption: "Chiudi" // @todo usare i18n
};
